import React from 'react';
import Select from 'react-select';

const Typeahead = React.forwardRef((props, ref) => {
  return (
    <Select
      ref={ref}
      id={props.id}
      name={props.name}
      inputId={props.inputId || props.id || props.name}
      isClearable={props?.isClearable ?? true}
      options={props.options}
      onChange={(selectedOption) => props.onChange?.(selectedOption)}
      onInputChange={(inputValue) => props.onInputChange?.(inputValue)}
      value={props.value}
      placeholder={props.placeholder || 'Select...'}
      isDisabled={props.disabled}
      className="col-sm-12"
      formatOptionLabel={(option) => option?.displayLabel || option?.label} // Display JSX
      filterOption={undefined}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          zIndex: 1000,
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#0061cd3d",
          primary: "#0061cd",
          primary50: "#0061cd3d",
        },
      })}
    />
  );
});

Typeahead.displayName = 'Typeahead';

export default Typeahead;